// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"2c2780dd","796":"b0db74a7"}[chunkId] + ".chunk.js";
};